import moment from 'moment-timezone';
import { API_DATE_FORMAT, CART_CATEGORYIDS } from "../constants";
import { timeToSeconds, secondsToTime, graphDateString } from "../helpers/moment-ex";
import {
    groupBy, isToday, isHistorical, isCrewView,
    isFarmView, isEGView, isElasticLoad,
    isCustom,
    isYesterday
} from '../helpers/common';
import { HARVESTING_CATEGORYIDS, PERSON_CATEGORY } from '../constants';

export const getWorkedAcres = (workedData, range) => {
    const worked = { workedAcres: 0, isLinearAcres: false };
    // const data = isToday(range) && workedData.today_data ? workedData.today_data : workedData.data;
    const data = (isToday(range) || isCustom(range) || isYesterday(range))  && workedData.today_data ? workedData.today_data : workedData.data;

    if (data && data.hasOwnProperty("linear_hectares")) {
        worked.workedAcres = (data.linear_hectares * 2.47105);
        worked.isLinearAcres = true;
    }
    else if (data && data.hasOwnProperty("worked_hectares")) {
        worked.workedAcres = (data.worked_hectares * 2.47105);
    }
    return worked;
}

export const getDefaultTargetAndSourceEgDetails = (egList) => {
    const sourceDefaultValues = {
        equipmentGroupId: null,
        equipmentGroupName: null,
        imgUrl: null,
        workTypeId: null,
        loadCount: null,
        acres: 0,
        utilization: 0
    };

    const targetDefaultValues = {
        equipmentGroupId: null,
        equipmentGroupName: null,
        imgUrl: null,
        workTypeId: null,
        loadCount: 0,
        avgLoadSeconds: 0,
        avgRoundTripSeconds: 0,
        primaryCategoryId: 0,
        loadCapacity: 0
    };

    let sourceDetailsById = {};
    let targetDetailsById = {};

    if (egList) egList.forEach(e => {

        //if eg is cart it will show in both EGs.
        if (CART_CATEGORYIDS.includes(e.primary_category_id)) {
            targetDetailsById[e.equipment_group_uuid] = {
                ...targetDefaultValues,
                equipmentGroupId: e.equipment_group_uuid,
                equipmentGroupName: e.equipment_group_name,
                imgUrl: e.img,
                workTypeId: e.work_type_id,
                primaryCategoryId: e.primary_category_id ? e.primary_category_id : 0,
                loadCapacity: e.load_capacity ? e.load_capacity : 0
            }
        }

        if (e.vehicle.is_truck && !CART_CATEGORYIDS.includes(e.primary_category_id)) {
            targetDetailsById[e.equipment_group_uuid] = {
                ...targetDefaultValues,
                equipmentGroupId: e.equipment_group_uuid,
                equipmentGroupName: e.equipment_group_name,
                imgUrl: e.img,
                workTypeId: e.work_type_id,
                primaryCategoryId: e.primary_category_id ? e.primary_category_id : 0,
                loadCapacity: e.load_capacity ? e.load_capacity : 0
            }
        } else {
            sourceDetailsById[e.equipment_group_uuid] = {
                ...sourceDefaultValues,
                equipmentGroupId: e.equipment_group_uuid,
                equipmentGroupName: e.equipment_group_name,
                imgUrl: e.img,
                workTypeId: e.work_type_id,
                loadCount: [...HARVESTING_CATEGORYIDS, PERSON_CATEGORY].indexOf(e.primary_category_id) >= 0 ? 0 : null,
                primaryCategoryId: e.primary_category_id ? e.primary_category_id : 0,
                loadCapacity: e.load_capacity ? e.load_capacity : 0
            }
        }
    })

    return { sourceDetailsById, targetDetailsById };
}

export const isMergeWorkElasticData = (payload) => {
    const message = { ...payload.data };
    let completedAcres = null, completedSeconds = null;
    if (payload.isLive) {
        completedAcres = message.summary && message.summary.work && !isNaN(message.summary.work.acres) && message.summary.work.acres !== 0
            ? message.summary.work.acres : null;
        completedSeconds = message.work_day && !isNaN(message.work_day.seconds) ? message.work_day.seconds : null;
    } else {
        const data = getCompletedInfo(message);
        completedAcres = data.completedAcres !== 0 ? data.completedAcres : null;
        completedSeconds = data.completedSeconds !== 0 ? data.completedSeconds : null;
    }
    return (completedAcres > 0 && completedSeconds > 0);
}

export const mergeCrewLoad = (id, dashboardState, message) => {
    if (!message.data) return;
    if (!isElasticLoad()) return;

    const { isLive, data } = message;
    return isLive
        ? crewLiveLoad(id, dashboardState, data)
        : crewHistoricalLoad(id, dashboardState, data);
}

const crewLiveLoad = (id, dashboardState, message) => {
    if (!message) return;
    if (!(message.equipment_groups && Array.isArray(message.equipment_groups))) return;
    if (!(dashboardState.crew.analyseById[id] && dashboardState.crew.analyseById[id].summary)) return;

    const egList = message.equipment_groups;
    let sumOfRoundTripSeconds = 0, sumOfLoadCount = 0, egCount = 0;

    for (const item of egList) {
        if (!Array.isArray(item.trips)) continue;
        const trips = item.trips.sort((a, b) => a.trip_id - b.trip_id);
        let prevStart = null, roundTripSeconds = 0;

        for (const trip of trips) {
            const currentStart = moment.utc(trip.start_time);
            roundTripSeconds += prevStart ? currentStart.diff(prevStart, "seconds") : 0;
            prevStart = currentStart;
        }

        egCount += (trips.length > 0) ? 1 : 0;
        sumOfLoadCount += trips.length;
        sumOfRoundTripSeconds += (trips.length > 0) ? (roundTripSeconds / trips.length) : 0;
    }

    const crewAvgRoundTripSeconds = (egCount > 0) ? (sumOfRoundTripSeconds / egCount) : 0;
    const crewAvgRoundTripTime = secondsToTime(crewAvgRoundTripSeconds);
    const { summary } = dashboardState.crew.analyseById[id];

    return {
        summary: {
            ...summary,
            payload: {
                ...summary.payload,
                load: {
                    total_loads: (sumOfLoadCount > 0)
                        ? sumOfLoadCount
                        : summary.payload.load.total_loads,
                    avg_roundtrip_load_time: (crewAvgRoundTripSeconds > 0)
                        ? crewAvgRoundTripTime
                        : summary.payload.load.avg_roundtrip_load_time
                }
            }
        }
    }
}

const crewHistoricalLoad = (id, dashboardState, message) => {
    if (!(message && message.data && message.data[id])) return;
    if (!(dashboardState.crew.analyseById[id] && dashboardState.crew.analyseById[id].summary)) return;

    const load = message.data[id];
    const loadCount = load.hasOwnProperty("load_count") ? parseInt(load.load_count) : 0;
    const roundTripSeconds = load.hasOwnProperty("round_trip_seconds") ? parseFloat(load.round_trip_seconds) : 0;
    const avgRoundTripTime = secondsToTime(roundTripSeconds);
    const { summary } = dashboardState.crew.analyseById[id];

    return {
        summary: {
            ...summary,
            payload: {
                ...summary.payload,
                load: {
                    total_loads: (loadCount > 0)
                        ? loadCount
                        : summary.payload.load.total_loads,
                    avg_roundtrip_load_time: (roundTripSeconds > 0)
                        ? avgRoundTripTime
                        : summary.payload.load.avg_roundtrip_load_time
                }
            }
        }
    };
}

export const mergeSourceEgKPIData = (message, range) => {
    if (!message) return;

    let egKPI = { acres: 0, utilization: 0, utilizationPerDay: [] };
    let completedAcres = null;
    let totalUtilization = 0;
    let utilizationPerDay = [];

    if (isToday(range)) {
        for (const key in message) {
            if (!(message[key].data && Array.isArray(message[key].data))) continue;
            const data = message[key].data[0];
            completedAcres = data && data.summary && data.summary.work && !isNaN(data.summary.work.acres) ? data.summary.work.acres : null;
            totalUtilization = data && data.summary && data.summary.work && data.summary.work.utilization ? data.summary.work.utilization : 0;
        }
    }
    else if (isHistorical(range)) {
        const completionInfo = getCompletedInfo(message);
        completedAcres = completionInfo.completedAcres;

        const utilizationInfo = getUtilization(message, "eg");
        totalUtilization = utilizationInfo.utilization;
        utilizationPerDay = utilizationInfo.utilizationGroup;
    }

    egKPI.acres = completedAcres ? completedAcres : 0;
    egKPI.utilization = (totalUtilization <= 100 ? totalUtilization : 100);
    egKPI.utilizationPerDay = utilizationPerDay;
    return egKPI;
}

export const mergeCrewSummaryKPI = (crewId, dashboardState, payload, initialState) => {
    if (!(payload && payload.data && dashboardState.crew.analyseById[crewId].summary)) return;

    const { summary } = dashboardState.crew.analyseById[crewId];
    const { isLive, data } = payload;
    const message = { ...data };

    let completedAcres = null, completedSeconds = null;
    if (isLive) {
        completedAcres = message.summary && message.summary.work && !isNaN(message.summary.work.acres) ? message.summary.work.acres : null;
        completedSeconds = message.work_day && !isNaN(message.work_day.seconds) ? message.work_day.seconds : null;
    }
    else {
        if (!(message[crewId] && message[crewId].data && Array.isArray(message[crewId].data))) return;
        const data = getCompletedInfo(message);
        completedAcres = data.completedAcres;
        completedSeconds = data.completedSeconds;
    }

    if (completedAcres === null) return;
    let acres = null, hours = null;

    //completed acres
    if (completedAcres > 0) {
        acres = summary.payload.acres ? summary.payload.acres : initialState.defaultState.crew.summary.payload.acres;
        acres = {
            ...acres,
            completed: completedAcres,
            remaining: (acres.planned > completedAcres) ? (acres.planned - completedAcres) : 0
        }
    }

    //completed hours
    if (completedSeconds > 0) {
        hours = summary.payload.hours ? summary.payload.hours : initialState.defaultState.crew.summary.payload.hours;
        const plannedSeconds = timeToSeconds(hours.planned);
        hours = {
            ...hours,
            completed: secondsToTime(completedSeconds),
            remaining: (plannedSeconds > completedSeconds) ? secondsToTime(plannedSeconds - completedSeconds) : 0
        }
    }

    return {
        summary: {
            ...summary,
            payload: {
                ...summary.payload,
                ...acres ? { acres } : {},
                ...hours ? { hours } : {}
            }
        }
    };
}

const getCompletedInfo = message => {
    let completedAcres = null, completedSeconds = null;

    for (const key in message) {
        if (!(message[key].data && Array.isArray(message[key].data))) continue;
        const data = message[key].data;

        for (const item of data) {
            completedAcres += item.summary && item.summary.work && !isNaN(item.summary.work.acres) ? item.summary.work.acres : 0;
            completedSeconds += item.work_day && !isNaN(item.work_day.seconds) ? item.work_day.seconds : 0;
        }
    }

    return { completedAcres, completedSeconds };
}

export const mergeCrewDonutKPI = (id, dashboardState, payload) => {
    if (!(payload && payload.data && dashboardState.crew.analyseById[id].donut)) return;

    const { isLive, data } = payload;
    const message = { ...data };
    let { donut } = dashboardState.crew.analyseById[id];
    let totalDuration = donut.payload.total_duration;
    let utilization = 0, actualWorkSeconds = 0, actualUtilizationSeconds = 0;

    if (isLive && message.summary && message.summary.work) {
        if (totalDuration.h === 0) totalDuration = { h: 24, m: 0 };
        utilization = message.summary.work.utilization;
        actualWorkSeconds = (message.work_day && message.work_day.seconds) ? message.work_day.seconds : 0;

        const utilizationSecondsKey = "average_utilization_seconds";
        actualUtilizationSeconds = !isNaN(message.summary.work[utilizationSecondsKey]) ? message.summary.work[utilizationSecondsKey] : 0;

    } else {
        const worked = getUtilization(message, "crew");
        utilization = worked.utilization;
        actualWorkSeconds = worked.actualWorkSeconds;
        actualUtilizationSeconds = worked.actualUtilizationSeconds;
    }

    donut = {
        ...donut,
        payload: {
            ...donut.payload,
            utilization: (utilization <= 100 ? utilization : 100),
            actual_work: secondsToTime(actualWorkSeconds),
            actual_utilization: secondsToTime(actualUtilizationSeconds),
            actual_work_percentage: convertPerc(actualWorkSeconds, totalDuration),
            actual_utilization_percentage: convertPerc(actualUtilizationSeconds, totalDuration)
        }
    };

    return { donut };
}

const getUtilization = (message, view) => {
    const utilizationSecondsKey = isEGView(view) || isFarmView(view) ? "seconds" : "average_utilization_seconds";
    let utilization = 0, actualWorkSeconds = 0, actualUtilizationSeconds = 0;
    let totalUtilization = 0, activeCount = 0;
    let utilizationGroup = [];

    for (const key in message) {
        if (!(message[key].data && Array.isArray(message[key].data))) continue;
        const data = message[key].data;
        let utilizationOfWorking = 0, workingDays = 0;

        for (const item of data) {
            //acutal work seconds
            actualWorkSeconds += (item.work_day && !isNaN(item.work_day.seconds)) ? item.work_day.seconds : 0;
            if (!item.summary && item.summary.work) continue;

            //actual utilization seconds
            actualUtilizationSeconds += !isNaN(item.summary.work[utilizationSecondsKey]) ? item.summary.work[utilizationSecondsKey] : 0;

            //utilization
            const utilizationPerDay = !isNaN(item.summary.work.utilization) ? item.summary.work.utilization : 0;
            utilizationGroup.push({ date: item.farm_day, utilization: utilizationPerDay, id: key });
            utilizationOfWorking += utilizationPerDay;
            workingDays += (utilizationPerDay > 0) ? 1 : 0;
        }

        utilizationOfWorking = (workingDays > 0) ? (utilizationOfWorking / workingDays) : 0;
        totalUtilization += utilizationOfWorking;
        activeCount += (utilizationOfWorking > 0) ? 1 : 0;
    }
    utilization = (activeCount > 0) ? (totalUtilization / activeCount) : 0;
    return { utilization, actualWorkSeconds, actualUtilizationSeconds, utilizationGroup };
}

export const mergeCrewGraphKPI = (id, dashboardState, payload, initialState, range, timezone) => {
    if (!(payload && payload.data && dashboardState.crew.analyseById[id].graph)) return;

    const { isLive, data } = payload;
    let message = { ...data };

    let graph = {};

    if (isToday(range)) {
        if (!isLive) {
            message = data[id] && Array.isArray(data[id].data) &&
                data[id].data.length > 0 ? data[id].data[0] : null;
        }

        graph = todayGraphForFarmAndCrew(id, dashboardState, message, timezone);
    } else
        graph = historicalGraphForAll(id, dashboardState, message, timezone, "crew");

    return {
        graph: {
            ...dashboardState.crew.analyseById[id].graph,
            payload: {
                ...initialState.defaultState.crew.graph.payload,
                ...dashboardState.crew.analyseById[id].graph.payload,
                ...graph
            }
        }
    };
}

const todayGraphForFarmAndCrew = (id, dashboardState, message, timezone) => {
    if (!(message && message.work_day && message.work_day.start_time)) return;
    if (!(message.detail && Array.isArray(message.detail.work) && message.detail.work.length > 0)) return;
    let actualLine = [], trendLine = [], plannedLine = [];

    const graph = dashboardState.crew.analyseById[id].graph.payload;
    const workDayStart = moment.utc(message.work_day.start_time).tz(timezone);
    const workDayEnd = moment.utc(message.work_day.end_time).tz(timezone);
    const startOfDay = workDayStart.clone().startOf('day');
    const endOfDay = workDayStart.clone().endOf('day').add("seconds", 1);

    //----------------Planned line calculation----------------------
    const plannedActivity = graph.planned_activity;
    if (plannedActivity.length > 0) {
        const plannedAcres = plannedActivity[0].acres;
        plannedLine.push({ time: startOfDay, acres: 0, ts: startOfDay.valueOf() });
        plannedLine.push({ time: workDayStart, acres: 0, ts: workDayStart.valueOf() });
        plannedLine.push({ time: workDayEnd, acres: plannedAcres, ts: workDayEnd.valueOf() });
        plannedLine.push({ time: endOfDay, acres: plannedAcres, ts: endOfDay.valueOf() });
        plannedLine = plannedLine.map(e => [graphDateString(e.time), e.acres]);
    }
    //--------------------------------------------------------------

    //----------------Actual line calculation-----------------------
    let actualAcres = 0, actualEndTime = null;
    if (message.detail.work.length > 0) {
        actualLine.push({ time: startOfDay, acres: actualAcres, ts: 0 });
        for (const item of message.detail.work) {
            const startTime = moment.utc(item.start).tz(timezone);
            const endTime = moment.utc(item.end).tz(timezone);
            if (!(workDayStart <= startTime && workDayEnd >= endTime)) continue;

            actualLine.push({ time: startTime, acres: actualAcres, ts: item.ts });
            actualAcres += item.acres;
            actualLine.push({ time: endTime, acres: actualAcres, ts: item.ts });
        }

        actualLine = actualLine.sort((a, b) => a.ts - b.ts);
        actualEndTime = actualLine[actualLine.length - 1].time;
        actualLine = actualLine.map(e => [graphDateString(e.time), e.acres]);
    }
    //---------------------------------------------------------------

    //-------------Trend line calculation----------------------------
    if (actualEndTime) {
        const trendEndTime = endOfDay;
        const remainingSecondsOfDay = trendEndTime.diff(actualEndTime, 'seconds');

        if (remainingSecondsOfDay > 0) {
            const workSeconds = message.summary && message.summary.work && !isNaN(message.summary.work.seconds) ? message.summary.work.seconds : 0;
            const acresPerSecond = (workSeconds > 0) ? (actualAcres / workSeconds) : 0;
            const trendAcres = (remainingSecondsOfDay * acresPerSecond);
            trendLine.push({ time: actualEndTime, acres: actualAcres, ts: actualEndTime.valueOf() });
            trendLine.push({ time: trendEndTime, acres: trendAcres, ts: trendEndTime.valueOf() });
        }

        let trendAcres = 0;
        trendLine = trendLine.sort((a, b) => a.ts - b.ts).map(e => {
            trendAcres += e.acres;
            return [graphDateString(e.time), trendAcres];
        });
    }
    //--------------------------------------------------------------

    return {
        actual: actualLine, trend: trendLine,
        ...(plannedLine.length > 0) ? { planned: plannedLine } : {}
    };
}

const historicalGraphForAll = (id, dashboardState, message, timezone, view) => {
    const graph = dashboardState.crew.analyseById[id].graph.payload;
    const planStartTime = (graph.planned.length > 0) ? graph.planned[0][0] : null;
    const isWorkInterval = isCrewView(view) || isEGView(view);

    const getWorkDate = (start, end) => {
        if (!(start && end)) return;
        const startTime = moment.utc(start).tz(timezone);
        const endTime = moment.utc(end).tz(timezone);

        return {
            startTime, endTime, ts: startTime.valueOf(),
            day: startTime.clone().startOf('day').valueOf()
        };
    }

    //---------------------Find work window------------------------
    let workWindow = [], workDetail = [];
    for (const key in message) {
        if (!(message[key].data && Array.isArray(message[key].data))) continue;
        const data = message[key].data;

        for (const item of data) {
            if (isWorkInterval) {
                let detailWork = [];
                if (isEGView(view)) {
                    detailWork = (item.work && Array.isArray(item.work)) ? item.work : [];
                    for (const work of detailWork) {
                        if (!work.gps) continue;
                        for (const gpsItem of work.gps) {
                            if (!gpsItem.from_last_gps) continue;
                            const time = moment.utc(gpsItem.time).tz(timezone);
                            workDetail.push({ time, acres: gpsItem.from_last_gps.acres, ts: time.valueOf() });
                        }
                    }
                } else {
                    detailWork = (item.detail && item.detail.work && Array.isArray(item.detail.work)) ? item.detail.work : [];
                    for (const work of detailWork) {
                        const date = getWorkDate(work.start, work.end);
                        workDetail.push({ ...date, acres: work.acres });
                    }
                }
            }

            if (!(item.work_day && item.work_day.start_time && item.work_day.end_time)) continue;
            const workDay = getWorkDate(item.work_day.start_time, item.work_day.end_time);
            workWindow.push(workDay);

            if (!isWorkInterval) {
                const acres = (item.summary && item.summary.work && !isNaN(item.summary.work.acres)) ? item.summary.work.acres : 0;
                workDetail.push({ ...workDay, acres });
            }
        }
    }

    workWindow = workWindow.sort((a, b) => a.ts - b.ts);
    workDetail = workDetail.sort((a, b) => a.ts - b.ts);
    //--------------------------------------------------------------

    //---------------------Find work activity-----------------------
    let workActivity = [];
    if (isWorkInterval) workActivity = workDetail;
    else {
        const detailGrouping = groupBy('day')(workDetail);
        for (const day in detailGrouping) {
            const list = detailGrouping[day].sort((a, b) => a.day - b.day);
            let minStarTime = null, maxEndTime = null, acres = 0;

            for (const item of list) {
                if (!minStarTime || minStarTime > item.startTime) minStarTime = item.startTime;
                if (!maxEndTime || maxEndTime < item.endTime) maxEndTime = item.endTime;
                acres += item.acres;
            }

            workActivity.push({
                startTime: minStarTime, endTime: maxEndTime,
                acres, day, ts: minStarTime.valueOf()
            });
        }
    }
    //---------------------------------------------------------------

    //----------------Planned line calculation-----------------------
    let planned = graph.planned, plannedLine = [], plannedAcres = 0, index = 0;
    const plannedActivity = graph.planned_activity;

    for (const item of plannedActivity) {
        let startTime = moment.utc(item.start_time);
        let endTime = moment.utc(item.end_time);

        const startDateStr = startTime.format(API_DATE_FORMAT);
        const findItems = workWindow.filter(e => e.startTime.format(API_DATE_FORMAT) === startDateStr);
        if (findItems.length > 0) {
            startTime = moment.utc(graphDateString(findItems[0].startTime));
            endTime = moment.utc(graphDateString(findItems[0].endTime));
        }

        if (index === 0) {
            const start = (planned.length > 0) ? moment.utc(planned[0][0]) : moment.utc(item.start_time);
            plannedLine.push({ time: graphDateString(start), acres: plannedAcres, ts: start.valueOf() });
        }

        plannedLine.push({ time: graphDateString(startTime), acres: plannedAcres, ts: startTime.valueOf() });
        plannedAcres += item.acres;
        plannedLine.push({ time: graphDateString(endTime), acres: plannedAcres, ts: endTime.valueOf() });

        if (index === plannedActivity.length - 1) {
            const end = (planned.length > 0) ? moment.utc(planned[planned.length - 1][0]) : moment.utc(item.end_time);
            plannedLine.push({ time: graphDateString(end), acres: plannedAcres, ts: end.valueOf() });
        }
        index++;
    }
    plannedLine = plannedLine.sort((a, b) => a.ts - b.ts).map(e => [e.time, e.acres]);
    //----------------------------------------------------------------

    //----------------Actual line calculation-------------------------
    let actualLine = [], totalAcres = 0;
    if (planStartTime && workActivity.length > 0) {
        actualLine.push({ time: planStartTime, acres: totalAcres, ts: 0 });

        if (isEGView(view)) {
            for (const item of workActivity) {
                actualLine.push({ time: graphDateString(item.time), acres: totalAcres, ts: item.ts });
                totalAcres += item.acres;
            }
        }
        else {
            for (const item of workActivity) {
                actualLine.push({ time: graphDateString(item.startTime), acres: totalAcres, ts: item.ts });
                totalAcres += item.acres;
                actualLine.push({ time: graphDateString(item.endTime), acres: totalAcres, ts: item.ts });
            }
        }
        actualLine = actualLine.sort((a, b) => a.ts - b.ts).map(e => [e.time, e.acres]);
    }

    if (actualLine.length > 0 && plannedLine.length > 0) {
        const planEndTime = plannedLine[plannedLine.length - 1][0];
        const planEndUTCTime = moment.utc(planEndTime);

        const actualEndTime = actualLine[actualLine.length - 1][0];
        const actualEndUTCTime = moment.utc(actualEndTime);

        if (planEndUTCTime < actualEndUTCTime) {
            const plannedAcres = plannedLine[plannedLine.length - 1][1];
            plannedLine.push([actualEndTime, plannedAcres]);
        } else if (planEndUTCTime > actualEndUTCTime) {
            const actualAcres = actualLine[actualLine.length - 1][1];
            actualLine.push([planEndTime, actualAcres]);
        }
    }
    //-----------------------------------------------------------------

    return { planned: plannedLine, actual: actualLine };
}

const convertPerc = (seconds, totalTime) =>
    parseFloat(((seconds / timeToSeconds(totalTime)) * 100).toFixed(2));